import React from 'react'
import PropTypes from 'prop-types'

function ButtonTabs ({ children, classNames, size, fullWidth }) {
  const classArray = [
    'button-tabs-container'
  ]

  return (
    <div className={classArray.concat(classNames).join(' ')}>
      <div className={'button-tabs button-tabs--' + size + (fullWidth ? ' w-full' : '')}>
        {children}
      </div>
    </div>
  )
}

ButtonTabs.defaultProps = {
  classNames: [],
  size: 'default',
  fullWidth: false
}

ButtonTabs.propTypes = {
  /**
     * Add class names to the wrapper, must be an array
     */
  classNames: PropTypes.array,
  /**
     * Control the size of the buttons.
     * Options: 'default', 'small'
     */
  size: PropTypes.string
}

export default ButtonTabs
